import axios from 'axios';

export default class Api {

    static get defaultOptions() {
        return {
            baseUrl: null,
            listUrl: null,
            downloadUrl: null,
            uploadUrl: null,
            axiosOptions: {}
        };
    }

    constructor(opts) {
        this.options = { ...this.constructor.defaultOptions, ...opts};

        if (this.options.baseUrl) {
            this.options.axiosOptions.baseURL = this.options.baseUrl;
        }

        this.axios = axios.create(this.options.axiosOptions);
    }

    list(path) {
        return this.axios.get(this.options.listUrl, { params: { 
            path,
            XDEBUG_SESSION_START:'netbeans-xdebug'
         } });
    }

    upload(data, config) {
        return this.axios.post(this.options.uploadUrl, data, config);
    }

    downloadUrl(file) {
        // TODO : proper
        if (this.options.downloadUrl)
            return this.options.baseUrl + this.options.downloadUrl + '?path='+file.path;
    }

}


// WEBPACK FOOTER //
// ./src/api.js